import React, { useState, useRef, useEffect } from 'react';

const ResizeHandle = ({ onResizeStart, onResize, onResizeEnd, minWidth = 50, maxWidth = 500 }) => {
  const [isResizing, setIsResizing] = useState(false);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const handleRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing) return;

      const deltaX = e.clientX - startX.current;
      const newWidth = Math.max(minWidth, Math.min(maxWidth, startWidth.current + deltaX));
      
      onResize(newWidth);
    };

    const handleMouseUp = () => {
      if (isResizing) {
        setIsResizing(false);
        onResizeEnd();
      }
    };

    if (isResizing) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
  }, [isResizing, onResize, onResizeEnd, minWidth, maxWidth]);

  const handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (onResizeStart) {
      onResizeStart();
    }

    setIsResizing(true);
    startX.current = e.clientX;

    // Get the current width of the parent th element
    const thElement = handleRef.current.closest('th');
    startWidth.current = thElement ? thElement.offsetWidth : minWidth;
  };

  return (
    <div
      ref={handleRef}
      className="table-resize-handle"
      onMouseDown={handleMouseDown}
      style={{
        position: 'absolute',
        right: -8,
        top: 0,
        bottom: 0,
        width: 16,
        cursor: 'col-resize',
        zIndex: 10,
        background: 'transparent'
      }}
    />
  );
};

export default ResizeHandle;
